import { render, staticRenderFns } from "./compose.vue?vue&type=template&id=729a1d94&scoped=true&"
import script from "./compose.vue?vue&type=script&lang=js&"
export * from "./compose.vue?vue&type=script&lang=js&"
import style0 from "./compose.vue?vue&type=style&index=0&id=729a1d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729a1d94",
  null
  
)

export default component.exports